import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class YoutubeVideoService {
  private readonly _youTubeApiTagId = 'youtube-api';

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  private get _hasBeenAddedToDom(): boolean {
    return !!this._document.getElementById(this._youTubeApiTagId);
  }

  public addYouTubeApiToDom(): Observable<boolean> {
    return new Observable<boolean>((observer: Subscriber<boolean>) => {
      if (this._hasBeenAddedToDom) {
        observer.next(true);
        observer.complete();
        return;
      }

      const youTubeScript = this._document.createElement('script');

      youTubeScript.id = this._youTubeApiTagId;
      youTubeScript.src = 'https://www.youtube.com/iframe_api';

      this._document.body.appendChild(youTubeScript);

      youTubeScript.onload = () => {
        observer.next(true);
        observer.complete();
      };
    });
  }
}
